<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30" id="offerSkuList">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th class="wd-50">
              <label class="mg-b-0 ckbox">
                <input
                  type="checkbox"
                  :checked="allCheck"
                  @change="allCheckChange($event)"
                />
                <span></span>
              </label>
            </th>
            <th class="wd-lg-300">{{ $t("distributor.物流单信息") }}</th>
            <th class="wd-lg-300">{{ $t("distributor.采购单信息") }}</th>
            <th class="wd-lg-300">
              {{ $t("distributor.客户信息") }}
            </th>
            <th class="wd-lg-300">
              {{ $t("distributor.包裹发货时间/最近更新时间") }}
            </th>
            <th class="wd-lg-100">{{ $t("distributor.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td class="valign-middle">
              <label class="mg-b-0 ckbox">
                <input type="checkbox" :value="item.id" v-model="checkArr" />
                <span></span>
              </label>
            </td>
            <td class="valign-middle tx-12 pd-b-30 pos-relative">
              <div class="media d-block d-sm-flex align-items-center">
                <div
                  class="
                    media-body
                    align-self-center
                    mg-t-10 mg-b-10
                    tx-12
                    pos-relative
                  "
                >
                  <p class="mg-b-5 tx-ellipsis2">
                    {{ $t("distributor.物流公司:") }}
                    <span class="tx-white"
                      >{{ item.companyName ? item.companyName : "---" }}({{
                        item.type != 9
                          ? $t("distributor.支持跟踪")
                          : $t("distributor.不支持跟踪")
                      }})</span
                    >
                  </p>
                  <p class="mg-b-5">
                    {{ $t("distributor.物流单号:") }}
                    <span class="tx-white">{{
                      item.trackNumber ? item.trackNumber : "---"
                    }}</span>
                    <a
                      v-if="item.trackNumber"
                      class="to-clipboard"
                      href="javascript:;"
                      :data-clipboard-text="item.trackNumber"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </p>
                  <p class="mg-b-5">
                    {{ $t("distributor.查询状态:") }}
                    <span v-if="item.status == 0" class="tx-gray-400">{{
                      $t(statusArr[item.status])
                    }}</span>
                    <span v-else-if="item.status == 4" class="tx-danger">{{
                      $t(statusArr[item.status])
                    }}</span>
                    <span v-else class="tx-success">{{
                      $t(statusArr[item.status])
                    }}</span>
                  </p>
                  <p
                    class="mg-b-0 d-flex align-items-center tx-ellipsis1"
                    v-if="item.trackInfo.length > 0"
                    style="max-width: 300px"
                  >
                    {{ $t("distributor.最新物流轨迹：") }}
                    <span class="d-inline-block mg-r-10 tx-white tx-ellipsis1"
                      >{{ item.trackInfo[0].time }}
                      {{ item.trackInfo[0].station }}</span
                    >
                    <a
                      class="tx-info"
                      href="javascript:;"
                      @click="openLog(index, 1)"
                      >{{ $t("distributor.更多") }}</a
                    >
                  </p>
                </div>
              </div>
              <p
                class="
                  mg-b-0
                  d-flex
                  align-items-center
                  pos-absolute
                  tx-ellipsis1 tx-danger
                "
                v-if="
                  item.type != 9 &&
                  item.status == 0 &&
                  diffTime(item.timeCreated) >= 2
                "
                style="width: 300%; bottom: 5px"
              >
                {{
                  $t(
                    "distributor.请注意：该包裹发货超过2天仍没有获得物流信息，为了避免在采购单结算时给双方带来不必要的麻烦，请及时确认物流单号是否填写正确！"
                  )
                }}
              </p>
            </td>
            <td class="valign-middle tx-12 pd-b-30">
              <div class="mg-b-0">
                <p class="mg-b-5">
                  {{ $t("distributor.采购单号:") }}
                  <span class="tx-white">{{
                    item.orderCode ? item.orderCode : "---"
                  }}</span>
                  <a
                    v-if="item.orderCode"
                    class="to-clipboard"
                    href="javascript:;"
                    :data-clipboard-text="item.orderCode"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                </p>
                <p class="mg-b-5">
                  {{ $t("distributor.采购单状态:") }}
                  <span class="tx-white">{{
                    orderStatus[item.orderStatus]
                  }}</span>
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12 pd-b-30">
              <div class="mg-b-0">
                <p class="mg-b-5">
                  {{ $t("distributor.客户名称:") }}
                  <span class="tx-white">{{
                    item.distributorName ? item.distributorName : "---"
                  }}</span>
                  <a
                    v-if="item.distributorName"
                    class="to-clipboard"
                    href="javascript:;"
                    :data-clipboard-text="item.distributorName"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                </p>
                <p class="mg-b-5">
                  {{ $t("distributor.联系人:") }}
                  <span class="tx-white">{{
                    item.subUserName ? item.subUserName : item.contact
                  }}</span>
                </p>
                <p class="mg-b-5">
                  {{ $t("distributor.手机:") }}
                  <span class="tx-white">{{
                    item.mobile ? item.mobile : "---"
                  }}</span>
                  <a
                    v-if="item.mobile"
                    class="to-clipboard"
                    href="javascript:;"
                    :data-clipboard-text="item.mobile"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                </p>
                <p class="mg-b-5">
                  QQ:
                  <span class="tx-white">{{ item.qq ? item.qq : "---" }}</span>
                  <a
                    v-if="item.qq"
                    class="to-clipboard"
                    href="javascript:;"
                    :data-clipboard-text="item.qq"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                </p>
                <p class="mg-b-5">
                  {{ $t("distributor.邮箱:") }}
                  <span class="tx-white">{{
                    item.email ? item.email : "---"
                  }}</span>
                  <a
                    v-if="item.email"
                    class="to-clipboard"
                    href="javascript:;"
                    :data-clipboard-text="item.email"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12 pd-b-30">
              <div class="mg-b-0">
                <p class="mg-b-5">
                  {{ $t("distributor.包裹发货时间:") }}
                  <span class="tx-white">{{
                    item.timeCreated ? item.timeCreated : "---"
                  }}</span>
                </p>
                <p class="mg-b-5">
                  {{ $t("distributor.最近更新时间:") }}
                  <span class="tx-white">{{
                    item.timeLastUpdate ? item.timeLastUpdate : "---"
                  }}</span>
                </p>
                <p class="mg-b-0">
                  <a
                    href="javascript:;"
                    class="tx-12 tx-gray-600 tx-underline log"
                    @click="addFollowUpRecords(index)"
                    >{{ $t("distributor.跟进记录") }}</a
                  >
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12 pd-b-30">
              <div class="mg-b-0 tx-white">
                <template v-if="isSysRights('Order.updateShippingInfo')">
                  <p
                    class="mg-b-5 tx-ellipsis2"
                    v-if="
                      item.orderStatus == 3 ||
                      item.orderStatus == 4 ||
                      item.orderStatus == 8
                    "
                  >
                    <a
                      href="javascript:;"
                      class="tx-info"
                      @click="openEdit(index)"
                      >{{ $t("distributor.修改物流单号") }}</a
                    >
                  </p>
                </template>
                <template v-if="isSysRights('Order.updateTrancInfoById')">
                  <p
                    class="mg-b-5 tx-ellipsis2"
                    v-if="
                      item.type != 9 &&
                      diffTime(item.timeCreated) > 0 &&
                      (!item.timeLastUpdate ||
                        diffTime(item.timeLastUpdate) >= 1)
                    "
                  >
                    <a
                      href="javascript:;"
                      class="tx-info"
                      @click="updateTrack(index)"
                      >{{ $t("distributor.刷新物流信息") }}</a
                    >
                  </p>
                </template>
                <p
                  class="mg-b-5 tx-ellipsis2"
                  v-if="isSysRights('Order.findOnePackge')"
                >
                  <a
                    href="javascript:;"
                    class="tx-info"
                    @click="checkExpress(index)"
                    >{{ $t("distributor.查看包裹明细") }}</a
                  >
                </p>
                <p class="mg-b-0">
                  <a
                    v-if="item.remark.length > 0"
                    href="javascript:;"
                    class="tx-12 tx-gray-600 tx-underline log"
                    @click="openLog(index, 2)"
                    >{{ $t("distributor.操作日志") }}</a
                  >
                </p>
              </div>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="6">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i
                >{{ $t("distributor.没有符合条件的采购单物流") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items", "check_arr"],
  data() {
    return {
      checkArr: [],
      // 查询状态
      statusArr: arrDict.logisticsStatus,
      // 采购单状态
      orderStatus: {
        1: this.$t("distributor.未付款"),
        2: this.$t("distributor.待配货"),
        3: this.$t("distributor.待发货"),
        4: this.$t("distributor.已发货"),
        5: this.$t("distributor.已完成"),
        6: this.$t("distributor.已取消"),
        7: this.$t("distributor.发货超时"),
        8: this.$t("distributor.部分发货"),
      },
    };
  },
  computed: {
    allCheck() {
      return this.items.length && this.checkArr.length == this.items.length;
    },
  },
  watch: {
    check_arr() {
      this.checkArr = this.check_arr;
    },
    checkArr() {
      this.$emit("updateCheckArr", this.checkArr);
    },
  },
  methods: {
    // 全选 全不选
    allCheckChange(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((item) => {
          this.checkArr.push(item.id);
        });
      }
    },
    diffTime(time) {
      let receiveTime = moment(time, "YYYY-MM-DD");
      let today = moment();
      return Number(today.diff(receiveTime, "days"));
    },
    timeFormat_1(val) {
      return moment(val, "YYYY-MM-DD h:mm:ss").format("YYYY-MM-DD");
    },
    openLog(i, type) {
      this.$emit("openLog", i, type);
    },
    openEdit(i) {
      this.$emit("openEdit", i);
    },
    updateTrack(i) {
      this.$emit("updateTrack", i);
    },
    checkExpress(i) {
      this.$emit("checkExpress", i);
    },
    addFollowUpRecords(index) {
      this.$emit("addFollowUpRecords", index);
    },
  },
};
</script>

<style scoped="scoped">
.table td.valign-middle,
.table th.valign-middle {
  padding-bottom: 20px;
}
</style>